/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from '@angular/core/src/linker/ng_module_factory';
import * as import1 from './browser.module';
import * as import2 from '@angular/common/src/common_module';
import * as import3 from '@angular/core/src/application_module';
import * as import4 from '@angular/platform-browser/src/browser';
import * as import5 from '@angular/http/src/http_module';
import * as import6 from '@angular/platform-browser/src/dom/shared_styles_host';
import * as import7 from 'angular2-universal/browser/universal-module';
import * as import8 from '@angular/forms/src/directives';
import * as import9 from '@angular/forms/src/form_providers';
import * as import10 from '@angular/router/src/router_module';
import * as import11 from '@angularclass/idle-preload/dist/index';
import * as import12 from 'ng2-bs-pagination/src/pagination.module';
import * as import13 from './app/shared/shared.module';
import * as import14 from './app/admin/modules/ng2-input-mask.module';
import * as import15 from 'ng2-file-upload/file-upload/file-upload.module';
import * as import16 from './app/admin/admin-routing.module';
import * as import17 from './app/admin/admin.module';
import * as import18 from './app/front/routing.module';
import * as import19 from 'ng-lazyload-image/src/lazyload-image.module';
import * as import20 from './app/front/front.module';
import * as import21 from './app/app.module';
import * as import22 from './app/shared/cache.service';
import * as import23 from '@angular/common/src/localization';
import * as import24 from '@angular/core/src/application_init';
import * as import25 from '@angular/core/src/testability/testability';
import * as import26 from '@angular/core/src/application_ref';
import * as import27 from '@angular/core/src/linker/compiler';
import * as import28 from '@angular/platform-browser/src/dom/events/hammer_gestures';
import * as import29 from '@angular/platform-browser/src/dom/events/event_manager';
import * as import30 from '@angular/platform-browser/src/dom/dom_renderer';
import * as import31 from '@angular/platform-browser/src/security/dom_sanitization_service';
import * as import32 from '@angular/core/src/linker/view_utils';
import * as import33 from '@angular/platform-browser/src/browser/title';
import * as import34 from '@angular/http/src/backends/browser_xhr';
import * as import35 from '@angular/http/src/base_response_options';
import * as import36 from '@angular/http/src/backends/xhr_backend';
import * as import37 from '@angular/http/src/base_request_options';
import * as import38 from '@angular/http/src/backends/browser_jsonp';
import * as import39 from '@angular/http/src/backends/jsonp_backend';
import * as import40 from '@angular/router/src/url_tree';
import * as import41 from '@angular/router/src/router_outlet_map';
import * as import42 from '@angular/common/src/location/location';
import * as import43 from '@angular/core/src/linker/system_js_ng_module_factory_loader';
import * as import44 from '@angular/router/src/router_preloader';
import * as import45 from '@angular/forms/src/directives/radio_control_value_accessor';
import * as import46 from '@angular/forms/src/form_builder';
import * as import47 from './app/admin/modules/ng2-input-mask.module/mask.service';
import * as import48 from './app/shared/config.service';
import * as import49 from './app/shared/utils.service';
import * as import50 from './app/shared/content.service';
import * as import51 from 'angular2-cookie/services/cookies.service';
import * as import52 from './app/front/cart.service';
import * as import53 from './app/shared/api.service';
import * as import54 from './app/shared/model/model.service';
import * as import55 from './app/shared/auth.service';
import * as import56 from './app/shared/auth-gard.service';
import * as import57 from './app/shared/data.service';
import * as import58 from './app/shared/search-elasticsearch.service';
import * as import59 from './app/shared/search.service';
import * as import60 from './angular2-meta';
import * as import61 from './app/shared/meta.service';
import * as import62 from './app/shared/notification.service';
import * as import63 from './app/shared/intl.service';
import * as import64 from '@angular/core/src/di/injector';
import * as import65 from './app/admin/admin-login.component.ngfactory';
import * as import66 from './app/admin/admin-root.component.ngfactory';
import * as import67 from './app/admin/content-pages.component.ngfactory';
import * as import68 from './app/admin/content-page-edit.component.ngfactory';
import * as import69 from './app/admin/content-records.component.ngfactory';
import * as import70 from './app/admin/content-record-edit.component.ngfactory';
import * as import71 from './app/admin/content-specials.component.ngfactory';
import * as import72 from './app/admin/content-special-edit.component.ngfactory';
import * as import73 from './app/admin/content-writings.component.ngfactory';
import * as import74 from './app/admin/content-writing-edit.component.ngfactory';
import * as import75 from './app/admin/content-messages.component.ngfactory';
import * as import76 from './app/admin/content-message-edit.component.ngfactory';
import * as import77 from './app/front/root.component.ngfactory';
import * as import78 from './app/front/home.component.ngfactory';
import * as import79 from './app/front/content-page.component.ngfactory';
import * as import80 from './app/front/content-writings.component.ngfactory';
import * as import81 from './app/front/content-writing.component.ngfactory';
import * as import82 from './app/front/content-records.component.ngfactory';
import * as import83 from './app/front/cart.component.ngfactory';
import * as import84 from './app/front/page-not-found.component.ngfactory';
import * as import85 from './app/front/content-record.component.ngfactory';
import * as import86 from './app/app.component.ngfactory';
import * as import87 from '@angular/platform-browser/src/dom/events/dom_events';
import * as import88 from '@angular/platform-browser/src/dom/events/key_events';
import * as import89 from '@angular/core/src/zone/ng_zone';
import * as import90 from '@angular/platform-browser/src/dom/debug/ng_probe';
import * as import91 from '@angular/common/src/location/platform_location';
import * as import92 from '@angular/common/src/location/location_strategy';
import * as import93 from './app/admin/admin-login.component';
import * as import94 from './app/admin/admin-root.component';
import * as import95 from './app/admin/content-pages.component';
import * as import96 from './app/admin/content-page-edit.component';
import * as import97 from './app/admin/content-records.component';
import * as import98 from './app/admin/content-record-edit.component';
import * as import99 from './app/admin/content-specials.component';
import * as import100 from './app/admin/content-special-edit.component';
import * as import101 from './app/admin/content-writings.component';
import * as import102 from './app/admin/content-writing-edit.component';
import * as import103 from './app/admin/content-messages.component';
import * as import104 from './app/admin/content-message-edit.component';
import * as import105 from './app/front/root.component';
import * as import106 from './app/front/home.component';
import * as import107 from './app/front/content-page.component';
import * as import108 from './app/front/content-writings.component';
import * as import109 from './app/front/content-writing.component';
import * as import110 from './app/front/content-records.component';
import * as import111 from './app/front/cart.component';
import * as import112 from './app/front/page-not-found.component';
import * as import113 from './app/front/content-record.component';
import * as import114 from '@angular/core/src/linker/element_ref';
import * as import115 from '@angular/core/src/render/api';
import * as import116 from 'angular2-universal/browser/env';
import * as import117 from '@angular/router/src/router';
import * as import118 from '@angular/core/src/console';
import * as import119 from '@angular/platform-browser/src/dom/dom_tokens';
import * as import120 from '@angular/core/src/i18n/tokens';
import * as import121 from '@angular/core/src/error_handler';
import * as import122 from '@angular/core/src/application_tokens';
import * as import123 from '@angular/platform-browser/src/dom/animation_driver';
import * as import124 from '@angular/core/src/security';
import * as import125 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import126 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import127 from '@angular/http/src/interfaces';
import * as import128 from '@angular/http/src/http';
import * as import129 from '@angular/core/src/linker/ng_module_factory_loader';
import * as import130 from '@angular/router/src/router_config_loader';
import * as import131 from '@angular/router/src/router_state';
class MainModuleInjector extends import0.NgModuleInjector<import1.MainModule> {
  _CommonModule_0:import2.CommonModule;
  _ApplicationModule_1:import3.ApplicationModule;
  _BrowserModule_2:import4.BrowserModule;
  _HttpModule_3:import5.HttpModule;
  _JsonpModule_4:import5.JsonpModule;
  _DOCUMENT_5:any;
  _DomSharedStylesHost_6:import6.DomSharedStylesHost;
  _SharedStylesHost_7:any;
  _UniversalModule_8:import7.UniversalModule;
  _InternalFormsSharedModule_9:import8.InternalFormsSharedModule;
  _FormsModule_10:import9.FormsModule;
  _ROUTER_FORROOT_GUARD_11:any;
  _RouterModule_12:import10.RouterModule;
  _IdlePreloadModule_13:import11.IdlePreloadModule;
  _ReactiveFormsModule_14:import9.ReactiveFormsModule;
  _PaginationModule_15:import12.PaginationModule;
  _SharedModule_16:import13.SharedModule;
  _Ng2InputMaskModule_17:import14.Ng2InputMaskModule;
  _FileUploadModule_18:import15.FileUploadModule;
  _AdminRoutingModule_19:import16.AdminRoutingModule;
  _AdminModule_20:import17.AdminModule;
  _FrontRoutingModule_21:import18.FrontRoutingModule;
  _LazyLoadImageModule_22:import19.LazyLoadImageModule;
  _FrontModule_23:import20.FrontModule;
  _AppModule_24:import21.AppModule;
  _LRU_25:any;
  _CacheService_26:import22.CacheService;
  _MainModule_27:import1.MainModule;
  __LOCALE_ID_28:any;
  __NgLocalization_29:import23.NgLocaleLocalization;
  _ErrorHandler_30:any;
  _ApplicationInitStatus_31:import24.ApplicationInitStatus;
  _Testability_32:import25.Testability;
  _ApplicationRef__33:import26.ApplicationRef_;
  __ApplicationRef_34:any;
  __Compiler_35:import27.Compiler;
  __APP_ID_36:any;
  __HAMMER_GESTURE_CONFIG_37:import28.HammerGestureConfig;
  __EVENT_MANAGER_PLUGINS_38:any[];
  __EventManager_39:import29.EventManager;
  __AnimationDriver_40:any;
  __DomRootRenderer_41:import30.DomRootRenderer_;
  __RootRenderer_42:any;
  __DomSanitizer_43:import31.DomSanitizerImpl;
  __Sanitizer_44:any;
  __ViewUtils_45:import32.ViewUtils;
  __IterableDiffers_46:any;
  __KeyValueDiffers_47:any;
  __Title_48:import33.Title;
  __BrowserXhr_49:import34.BrowserXhr;
  __ResponseOptions_50:import35.BaseResponseOptions;
  __XSRFStrategy_51:any;
  __XHRBackend_52:import36.XHRBackend;
  __RequestOptions_53:import37.BaseRequestOptions;
  __Http_54:any;
  __BrowserJsonp_55:import38.BrowserJsonp;
  __JSONPBackend_56:import39.JSONPBackend_;
  __Jsonp_57:any;
  __UNIVERSAL_CACHE_58:any;
  __AUTO_PREBOOT_59:any;
  __UrlSerializer_60:import40.DefaultUrlSerializer;
  __RouterOutletMap_61:import41.RouterOutletMap;
  __ROUTER_CONFIGURATION_62:any;
  __LocationStrategy_63:any;
  __Location_64:import42.Location;
  __NgModuleFactoryLoader_65:import43.SystemJsNgModuleLoader;
  __ROUTES_66:any[];
  __Router_67:any;
  __REQUEST_IDLE_CALLBACK_68:any;
  __IdlePreload_69:import11.IdlePreload;
  __PreloadingStrategy_70:any;
  _RouterPreloader_71:import44.RouterPreloader;
  __APP_BOOTSTRAP_LISTENER_72:any[];
  __RadioControlRegistry_73:import45.RadioControlRegistry;
  __FormBuilder_74:import46.FormBuilder;
  __MaskService_75:import47.MaskService;
  __ConfigService_76:import48.ConfigService;
  __UtilsService_77:import49.UtilsService;
  __ContentService_78:import50.ContentService;
  __CookieService_79:import51.CookieService;
  __CartService_80:import52.CartService;
  __ApiService_81:import53.ApiService;
  __ModelService_82:import54.ModelService;
  __AuthService_83:import55.AuthService;
  __AuthGuard_84:import56.AuthGuard;
  __DataService_85:import57.DataService;
  __ElasticSearchService_86:import58.ElasticSearchService;
  __SearchService_87:import59.SearchService;
  __Meta_88:import60.Meta;
  __MetaService_89:import61.MetaService;
  __NotificationService_90:import62.NotificationService;
  __IntlService_91:import63.IntlService;
  __ActivatedRoute_92:any;
  __NoPreloading_93:import44.NoPreloading;
  __PreloadAllModules_94:import44.PreloadAllModules;
  __isBrowser_95:any;
  __isNode_96:any;
  __req_97:any;
  __res_98:any;
  constructor(parent:import64.Injector) {
    super(parent,[
      import65.AdminLoginComponentNgFactory,
      import66.AdminRootComponentNgFactory,
      import67.ContentPagesComponentNgFactory,
      import67.ContentPagesComponentNgFactory,
      import68.ContentPageEditComponentNgFactory,
      import69.ContentRecordsComponentNgFactory,
      import69.ContentRecordsComponentNgFactory,
      import69.ContentRecordsComponentNgFactory,
      import70.ContentRecordEditComponentNgFactory,
      import71.ContentSpecialsComponentNgFactory,
      import71.ContentSpecialsComponentNgFactory,
      import72.ContentSpecialEditComponentNgFactory,
      import73.ContentWritingsComponentNgFactory,
      import73.ContentWritingsComponentNgFactory,
      import74.ContentWritingEditComponentNgFactory,
      import75.ContentMessagesComponentNgFactory,
      import75.ContentMessagesComponentNgFactory,
      import76.ContentMessageEditComponentNgFactory,
      import66.AdminRootComponentNgFactory,
      import67.ContentPagesComponentNgFactory,
      import67.ContentPagesComponentNgFactory,
      import68.ContentPageEditComponentNgFactory,
      import69.ContentRecordsComponentNgFactory,
      import69.ContentRecordsComponentNgFactory,
      import69.ContentRecordsComponentNgFactory,
      import70.ContentRecordEditComponentNgFactory,
      import71.ContentSpecialsComponentNgFactory,
      import71.ContentSpecialsComponentNgFactory,
      import72.ContentSpecialEditComponentNgFactory,
      import73.ContentWritingsComponentNgFactory,
      import73.ContentWritingsComponentNgFactory,
      import74.ContentWritingEditComponentNgFactory,
      import75.ContentMessagesComponentNgFactory,
      import75.ContentMessagesComponentNgFactory,
      import76.ContentMessageEditComponentNgFactory,
      import77.FrontRootComponentNgFactory,
      import78.HomeComponentNgFactory,
      import78.HomeComponentNgFactory,
      import78.HomeComponentNgFactory,
      import79.ContentPageComponentNgFactory,
      import80.ContentWritingsComponentNgFactory,
      import81.ContentWritingComponentNgFactory,
      import82.ContentRecordsComponentNgFactory,
      import82.ContentRecordsComponentNgFactory,
      import82.ContentRecordsComponentNgFactory,
      import83.CartComponentNgFactory,
      import84.PageNotFoundComponentNgFactory,
      import85.ContentRecordComponentNgFactory,
      import77.FrontRootComponentNgFactory,
      import78.HomeComponentNgFactory,
      import78.HomeComponentNgFactory,
      import78.HomeComponentNgFactory,
      import79.ContentPageComponentNgFactory,
      import80.ContentWritingsComponentNgFactory,
      import81.ContentWritingComponentNgFactory,
      import82.ContentRecordsComponentNgFactory,
      import82.ContentRecordsComponentNgFactory,
      import82.ContentRecordsComponentNgFactory,
      import83.CartComponentNgFactory,
      import84.PageNotFoundComponentNgFactory,
      import85.ContentRecordComponentNgFactory,
      import86.AppComponentNgFactory
    ]
    ,[import86.AppComponentNgFactory]);
  }
  get _LOCALE_ID_28():any {
    if ((this.__LOCALE_ID_28 == (null as any))) { (this.__LOCALE_ID_28 = 'en-US'); }
    return this.__LOCALE_ID_28;
  }
  get _NgLocalization_29():import23.NgLocaleLocalization {
    if ((this.__NgLocalization_29 == (null as any))) { (this.__NgLocalization_29 = new import23.NgLocaleLocalization(this._LOCALE_ID_28)); }
    return this.__NgLocalization_29;
  }
  get _ApplicationRef_34():any {
    if ((this.__ApplicationRef_34 == (null as any))) { (this.__ApplicationRef_34 = this._ApplicationRef__33); }
    return this.__ApplicationRef_34;
  }
  get _Compiler_35():import27.Compiler {
    if ((this.__Compiler_35 == (null as any))) { (this.__Compiler_35 = new import27.Compiler()); }
    return this.__Compiler_35;
  }
  get _APP_ID_36():any {
    if ((this.__APP_ID_36 == (null as any))) { (this.__APP_ID_36 = import7.appIdFactory()); }
    return this.__APP_ID_36;
  }
  get _HAMMER_GESTURE_CONFIG_37():import28.HammerGestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_37 == (null as any))) { (this.__HAMMER_GESTURE_CONFIG_37 = new import28.HammerGestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_37;
  }
  get _EVENT_MANAGER_PLUGINS_38():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_38 == (null as any))) { (this.__EVENT_MANAGER_PLUGINS_38 = [
      new import87.DomEventsPlugin(),
      new import88.KeyEventsPlugin(),
      new import28.HammerGesturesPlugin(this._HAMMER_GESTURE_CONFIG_37)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_38;
  }
  get _EventManager_39():import29.EventManager {
    if ((this.__EventManager_39 == (null as any))) { (this.__EventManager_39 = new import29.EventManager(this._EVENT_MANAGER_PLUGINS_38,this.parent.get(import89.NgZone))); }
    return this.__EventManager_39;
  }
  get _AnimationDriver_40():any {
    if ((this.__AnimationDriver_40 == (null as any))) { (this.__AnimationDriver_40 = import4._resolveDefaultAnimationDriver()); }
    return this.__AnimationDriver_40;
  }
  get _DomRootRenderer_41():import30.DomRootRenderer_ {
    if ((this.__DomRootRenderer_41 == (null as any))) { (this.__DomRootRenderer_41 = new import30.DomRootRenderer_(this._DOCUMENT_5,this._EventManager_39,this._DomSharedStylesHost_6,this._AnimationDriver_40)); }
    return this.__DomRootRenderer_41;
  }
  get _RootRenderer_42():any {
    if ((this.__RootRenderer_42 == (null as any))) { (this.__RootRenderer_42 = import90._createConditionalRootRenderer(this._DomRootRenderer_41,this.parent.get(import90.NgProbeToken,(null as any)))); }
    return this.__RootRenderer_42;
  }
  get _DomSanitizer_43():import31.DomSanitizerImpl {
    if ((this.__DomSanitizer_43 == (null as any))) { (this.__DomSanitizer_43 = new import31.DomSanitizerImpl()); }
    return this.__DomSanitizer_43;
  }
  get _Sanitizer_44():any {
    if ((this.__Sanitizer_44 == (null as any))) { (this.__Sanitizer_44 = this._DomSanitizer_43); }
    return this.__Sanitizer_44;
  }
  get _ViewUtils_45():import32.ViewUtils {
    if ((this.__ViewUtils_45 == (null as any))) { (this.__ViewUtils_45 = new import32.ViewUtils(this._RootRenderer_42,this._APP_ID_36,this._Sanitizer_44)); }
    return this.__ViewUtils_45;
  }
  get _IterableDiffers_46():any {
    if ((this.__IterableDiffers_46 == (null as any))) { (this.__IterableDiffers_46 = import3._iterableDiffersFactory()); }
    return this.__IterableDiffers_46;
  }
  get _KeyValueDiffers_47():any {
    if ((this.__KeyValueDiffers_47 == (null as any))) { (this.__KeyValueDiffers_47 = import3._keyValueDiffersFactory()); }
    return this.__KeyValueDiffers_47;
  }
  get _Title_48():import33.Title {
    if ((this.__Title_48 == (null as any))) { (this.__Title_48 = new import33.Title()); }
    return this.__Title_48;
  }
  get _BrowserXhr_49():import34.BrowserXhr {
    if ((this.__BrowserXhr_49 == (null as any))) { (this.__BrowserXhr_49 = new import34.BrowserXhr()); }
    return this.__BrowserXhr_49;
  }
  get _ResponseOptions_50():import35.BaseResponseOptions {
    if ((this.__ResponseOptions_50 == (null as any))) { (this.__ResponseOptions_50 = new import35.BaseResponseOptions()); }
    return this.__ResponseOptions_50;
  }
  get _XSRFStrategy_51():any {
    if ((this.__XSRFStrategy_51 == (null as any))) { (this.__XSRFStrategy_51 = import5._createDefaultCookieXSRFStrategy()); }
    return this.__XSRFStrategy_51;
  }
  get _XHRBackend_52():import36.XHRBackend {
    if ((this.__XHRBackend_52 == (null as any))) { (this.__XHRBackend_52 = new import36.XHRBackend(this._BrowserXhr_49,this._ResponseOptions_50,this._XSRFStrategy_51)); }
    return this.__XHRBackend_52;
  }
  get _RequestOptions_53():import37.BaseRequestOptions {
    if ((this.__RequestOptions_53 == (null as any))) { (this.__RequestOptions_53 = new import37.BaseRequestOptions()); }
    return this.__RequestOptions_53;
  }
  get _Http_54():any {
    if ((this.__Http_54 == (null as any))) { (this.__Http_54 = import5.httpFactory(this._XHRBackend_52,this._RequestOptions_53)); }
    return this.__Http_54;
  }
  get _BrowserJsonp_55():import38.BrowserJsonp {
    if ((this.__BrowserJsonp_55 == (null as any))) { (this.__BrowserJsonp_55 = new import38.BrowserJsonp()); }
    return this.__BrowserJsonp_55;
  }
  get _JSONPBackend_56():import39.JSONPBackend_ {
    if ((this.__JSONPBackend_56 == (null as any))) { (this.__JSONPBackend_56 = new import39.JSONPBackend_(this._BrowserJsonp_55,this._ResponseOptions_50)); }
    return this.__JSONPBackend_56;
  }
  get _Jsonp_57():any {
    if ((this.__Jsonp_57 == (null as any))) { (this.__Jsonp_57 = import5.jsonpFactory(this._JSONPBackend_56,this._RequestOptions_53)); }
    return this.__Jsonp_57;
  }
  get _UNIVERSAL_CACHE_58():any {
    if ((this.__UNIVERSAL_CACHE_58 == (null as any))) { (this.__UNIVERSAL_CACHE_58 = import7.universalCacheFactory()); }
    return this.__UNIVERSAL_CACHE_58;
  }
  get _AUTO_PREBOOT_59():any {
    if ((this.__AUTO_PREBOOT_59 == (null as any))) { (this.__AUTO_PREBOOT_59 = false); }
    return this.__AUTO_PREBOOT_59;
  }
  get _UrlSerializer_60():import40.DefaultUrlSerializer {
    if ((this.__UrlSerializer_60 == (null as any))) { (this.__UrlSerializer_60 = new import40.DefaultUrlSerializer()); }
    return this.__UrlSerializer_60;
  }
  get _RouterOutletMap_61():import41.RouterOutletMap {
    if ((this.__RouterOutletMap_61 == (null as any))) { (this.__RouterOutletMap_61 = new import41.RouterOutletMap()); }
    return this.__RouterOutletMap_61;
  }
  get _ROUTER_CONFIGURATION_62():any {
    if ((this.__ROUTER_CONFIGURATION_62 == (null as any))) { (this.__ROUTER_CONFIGURATION_62 = {
      useHash: false,
      preloadingStrategy: import11.IdlePreload
    }
    ); }
    return this.__ROUTER_CONFIGURATION_62;
  }
  get _LocationStrategy_63():any {
    if ((this.__LocationStrategy_63 == (null as any))) { (this.__LocationStrategy_63 = import10.provideLocationStrategy(this.parent.get(import91.PlatformLocation),this.parent.get(import92.APP_BASE_HREF,(null as any)),this._ROUTER_CONFIGURATION_62)); }
    return this.__LocationStrategy_63;
  }
  get _Location_64():import42.Location {
    if ((this.__Location_64 == (null as any))) { (this.__Location_64 = new import42.Location(this._LocationStrategy_63)); }
    return this.__Location_64;
  }
  get _NgModuleFactoryLoader_65():import43.SystemJsNgModuleLoader {
    if ((this.__NgModuleFactoryLoader_65 == (null as any))) { (this.__NgModuleFactoryLoader_65 = new import43.SystemJsNgModuleLoader(this._Compiler_35,this.parent.get(import43.SystemJsNgModuleLoaderConfig,(null as any)))); }
    return this.__NgModuleFactoryLoader_65;
  }
  get _ROUTES_66():any[] {
    if ((this.__ROUTES_66 == (null as any))) { (this.__ROUTES_66 = [
      [
        {
          path: 'admin/login',
          component: import93.AdminLoginComponent
        }
        ,
        {
          path: 'admin',
          component: import94.AdminRootComponent,
          children: [
            {
              path: '',
              redirectTo: 'records',
              pathMatch: 'full'
            }
            ,
            {
              path: 'pages',
              component: import95.ContentPagesComponent
            }
            ,
            {
              path: 'pages/reload',
              component: import95.ContentPagesComponent
            }
            ,
            {
              path: 'page/edit/:id',
              component: import96.ContentPageEditComponent
            }
            ,
            {
              path: 'records',
              component: import97.ContentRecordsComponent
            }
            ,
            {
              path: 'records/active/:active',
              component: import97.ContentRecordsComponent
            }
            ,
            {
              path: 'records/reload',
              component: import97.ContentRecordsComponent
            }
            ,
            {
              path: 'record/edit/:id',
              component: import98.ContentRecordEditComponent
            }
            ,
            {
              path: 'specials',
              component: import99.ContentSpecialsComponent
            }
            ,
            {
              path: 'specials/reload',
              component: import99.ContentSpecialsComponent
            }
            ,
            {
              path: 'special/edit/:id',
              component: import100.ContentSpecialEditComponent
            }
            ,
            {
              path: 'writings',
              component: import101.ContentWritingsComponent
            }
            ,
            {
              path: 'writings/reload',
              component: import101.ContentWritingsComponent
            }
            ,
            {
              path: 'writing/edit/:id',
              component: import102.ContentWritingEditComponent
            }
            ,
            {
              path: 'messages',
              component: import103.ContentMessagesComponent
            }
            ,
            {
              path: 'messages/reload',
              component: import103.ContentMessagesComponent
            }
            ,
            {
              path: 'message/edit/:id',
              component: import104.ContentMessageEditComponent
            }

          ]
          ,
          canActivateChild: [import56.AuthGuard]
        }
        ,
        {
          path: ':lg/admin',
          component: import94.AdminRootComponent,
          children: [
            {
              path: '',
              redirectTo: 'records',
              pathMatch: 'full'
            }
            ,
            {
              path: 'pages',
              component: import95.ContentPagesComponent
            }
            ,
            {
              path: 'pages/reload',
              component: import95.ContentPagesComponent
            }
            ,
            {
              path: 'page/edit/:id',
              component: import96.ContentPageEditComponent
            }
            ,
            {
              path: 'records',
              component: import97.ContentRecordsComponent
            }
            ,
            {
              path: 'records/active/:active',
              component: import97.ContentRecordsComponent
            }
            ,
            {
              path: 'records/reload',
              component: import97.ContentRecordsComponent
            }
            ,
            {
              path: 'record/edit/:id',
              component: import98.ContentRecordEditComponent
            }
            ,
            {
              path: 'specials',
              component: import99.ContentSpecialsComponent
            }
            ,
            {
              path: 'specials/reload',
              component: import99.ContentSpecialsComponent
            }
            ,
            {
              path: 'special/edit/:id',
              component: import100.ContentSpecialEditComponent
            }
            ,
            {
              path: 'writings',
              component: import101.ContentWritingsComponent
            }
            ,
            {
              path: 'writings/reload',
              component: import101.ContentWritingsComponent
            }
            ,
            {
              path: 'writing/edit/:id',
              component: import102.ContentWritingEditComponent
            }
            ,
            {
              path: 'messages',
              component: import103.ContentMessagesComponent
            }
            ,
            {
              path: 'messages/reload',
              component: import103.ContentMessagesComponent
            }
            ,
            {
              path: 'message/edit/:id',
              component: import104.ContentMessageEditComponent
            }

          ]
          ,
          canActivateChild: [import56.AuthGuard]
        }

      ]
      ,
      [
        {
          path: '',
          component: import105.FrontRootComponent,
          children: [
            {
              path: '',
              component: import106.HomeComponent
            }
            ,
            {
              path: 'fr',
              component: import106.HomeComponent
            }
            ,
            {
              path: 'en',
              component: import106.HomeComponent
            }
            ,
            {
              path: 'page/:url',
              component: import107.ContentPageComponent
            }
            ,
            {
              path: 'writings',
              component: import108.ContentWritingsComponent
            }
            ,
            {
              path: 'writing/:url',
              component: import109.ContentWritingComponent
            }
            ,
            {
              path: 'catalogue',
              component: import110.ContentRecordsComponent
            }
            ,
            {
              path: 'catalogue/:type',
              component: import110.ContentRecordsComponent
            }
            ,
            {
              path: 'catalogue/:field/:value',
              component: import110.ContentRecordsComponent
            }
            ,
            {
              path: 'cart',
              component: import111.CartComponent
            }
            ,
            {
              path: 'page-not-found',
              component: import112.PageNotFoundComponent
            }
            ,
            {
              path: ':url',
              component: import113.ContentRecordComponent
            }

          ]

        }
        ,
        {
          path: ':lg',
          component: import105.FrontRootComponent,
          children: [
            {
              path: '',
              component: import106.HomeComponent
            }
            ,
            {
              path: 'fr',
              component: import106.HomeComponent
            }
            ,
            {
              path: 'en',
              component: import106.HomeComponent
            }
            ,
            {
              path: 'page/:url',
              component: import107.ContentPageComponent
            }
            ,
            {
              path: 'writings',
              component: import108.ContentWritingsComponent
            }
            ,
            {
              path: 'writing/:url',
              component: import109.ContentWritingComponent
            }
            ,
            {
              path: 'catalogue',
              component: import110.ContentRecordsComponent
            }
            ,
            {
              path: 'catalogue/:type',
              component: import110.ContentRecordsComponent
            }
            ,
            {
              path: 'catalogue/:field/:value',
              component: import110.ContentRecordsComponent
            }
            ,
            {
              path: 'cart',
              component: import111.CartComponent
            }
            ,
            {
              path: 'page-not-found',
              component: import112.PageNotFoundComponent
            }
            ,
            {
              path: ':url',
              component: import113.ContentRecordComponent
            }

          ]

        }

      ]
      ,
      ([] as any[])
    ]
    ); }
    return this.__ROUTES_66;
  }
  get _Router_67():any {
    if ((this.__Router_67 == (null as any))) { (this.__Router_67 = import10.setupRouter(this._ApplicationRef_34,this._UrlSerializer_60,this._RouterOutletMap_61,this._Location_64,this,this._NgModuleFactoryLoader_65,this._Compiler_35,this._ROUTES_66,this._ROUTER_CONFIGURATION_62)); }
    return this.__Router_67;
  }
  get _REQUEST_IDLE_CALLBACK_68():any {
    if ((this.__REQUEST_IDLE_CALLBACK_68 == (null as any))) { (this.__REQUEST_IDLE_CALLBACK_68 = import11._requestIdle(this.parent.get(import89.NgZone))); }
    return this.__REQUEST_IDLE_CALLBACK_68;
  }
  get _IdlePreload_69():import11.IdlePreload {
    if ((this.__IdlePreload_69 == (null as any))) { (this.__IdlePreload_69 = new import11.IdlePreload(this.parent.get(import89.NgZone),this._REQUEST_IDLE_CALLBACK_68)); }
    return this.__IdlePreload_69;
  }
  get _PreloadingStrategy_70():any {
    if ((this.__PreloadingStrategy_70 == (null as any))) { (this.__PreloadingStrategy_70 = this._IdlePreload_69); }
    return this.__PreloadingStrategy_70;
  }
  get _APP_BOOTSTRAP_LISTENER_72():any[] {
    if ((this.__APP_BOOTSTRAP_LISTENER_72 == (null as any))) { (this.__APP_BOOTSTRAP_LISTENER_72 = [
      import7.appBootstrapListenerFactory(this._AUTO_PREBOOT_59),
      import10.initialRouterNavigation(this._Router_67,this._ApplicationRef_34,this._RouterPreloader_71,this._ROUTER_CONFIGURATION_62)
    ]
    ); }
    return this.__APP_BOOTSTRAP_LISTENER_72;
  }
  get _RadioControlRegistry_73():import45.RadioControlRegistry {
    if ((this.__RadioControlRegistry_73 == (null as any))) { (this.__RadioControlRegistry_73 = new import45.RadioControlRegistry()); }
    return this.__RadioControlRegistry_73;
  }
  get _FormBuilder_74():import46.FormBuilder {
    if ((this.__FormBuilder_74 == (null as any))) { (this.__FormBuilder_74 = new import46.FormBuilder()); }
    return this.__FormBuilder_74;
  }
  get _MaskService_75():import47.MaskService {
    if ((this.__MaskService_75 == (null as any))) { (this.__MaskService_75 = new import47.MaskService()); }
    return this.__MaskService_75;
  }
  get _ConfigService_76():import48.ConfigService {
    if ((this.__ConfigService_76 == (null as any))) { (this.__ConfigService_76 = new import48.ConfigService()); }
    return this.__ConfigService_76;
  }
  get _UtilsService_77():import49.UtilsService {
    if ((this.__UtilsService_77 == (null as any))) { (this.__UtilsService_77 = new import49.UtilsService(this._ConfigService_76,this._Router_67)); }
    return this.__UtilsService_77;
  }
  get _ContentService_78():import50.ContentService {
    if ((this.__ContentService_78 == (null as any))) { (this.__ContentService_78 = new import50.ContentService(this._Http_54,this._Router_67)); }
    return this.__ContentService_78;
  }
  get _CookieService_79():import51.CookieService {
    if ((this.__CookieService_79 == (null as any))) { (this.__CookieService_79 = new import51.CookieService()); }
    return this.__CookieService_79;
  }
  get _CartService_80():import52.CartService {
    if ((this.__CartService_80 == (null as any))) { (this.__CartService_80 = new import52.CartService(this._ConfigService_76,this._UtilsService_77,this._Router_67,this._ContentService_78,this._CookieService_79,this._Http_54)); }
    return this.__CartService_80;
  }
  get _ApiService_81():import53.ApiService {
    if ((this.__ApiService_81 == (null as any))) { (this.__ApiService_81 = new import53.ApiService(this._Http_54)); }
    return this.__ApiService_81;
  }
  get _ModelService_82():import54.ModelService {
    if ((this.__ModelService_82 == (null as any))) { (this.__ModelService_82 = new import54.ModelService(this._ApiService_81,this._CacheService_26)); }
    return this.__ModelService_82;
  }
  get _AuthService_83():import55.AuthService {
    if ((this.__AuthService_83 == (null as any))) { (this.__AuthService_83 = new import55.AuthService(this._Http_54)); }
    return this.__AuthService_83;
  }
  get _AuthGuard_84():import56.AuthGuard {
    if ((this.__AuthGuard_84 == (null as any))) { (this.__AuthGuard_84 = new import56.AuthGuard(this._AuthService_83,this._Router_67)); }
    return this.__AuthGuard_84;
  }
  get _DataService_85():import57.DataService {
    if ((this.__DataService_85 == (null as any))) { (this.__DataService_85 = new import57.DataService(this._Http_54)); }
    return this.__DataService_85;
  }
  get _ElasticSearchService_86():import58.ElasticSearchService {
    if ((this.__ElasticSearchService_86 == (null as any))) { (this.__ElasticSearchService_86 = new import58.ElasticSearchService(this._Http_54)); }
    return this.__ElasticSearchService_86;
  }
  get _SearchService_87():import59.SearchService {
    if ((this.__SearchService_87 == (null as any))) { (this.__SearchService_87 = new import59.SearchService(this._Http_54,this._ElasticSearchService_86)); }
    return this.__SearchService_87;
  }
  get _Meta_88():import60.Meta {
    if ((this.__Meta_88 == (null as any))) { (this.__Meta_88 = new import60.Meta(this._DOCUMENT_5)); }
    return this.__Meta_88;
  }
  get _MetaService_89():import61.MetaService {
    if ((this.__MetaService_89 == (null as any))) { (this.__MetaService_89 = new import61.MetaService(this._Meta_88)); }
    return this.__MetaService_89;
  }
  get _NotificationService_90():import62.NotificationService {
    if ((this.__NotificationService_90 == (null as any))) { (this.__NotificationService_90 = new import62.NotificationService(this.parent.get(import114.ElementRef),this.parent.get(import115.Renderer))); }
    return this.__NotificationService_90;
  }
  get _IntlService_91():import63.IntlService {
    if ((this.__IntlService_91 == (null as any))) { (this.__IntlService_91 = new import63.IntlService(this._Http_54)); }
    return this.__IntlService_91;
  }
  get _ActivatedRoute_92():any {
    if ((this.__ActivatedRoute_92 == (null as any))) { (this.__ActivatedRoute_92 = import10.rootRoute(this._Router_67)); }
    return this.__ActivatedRoute_92;
  }
  get _NoPreloading_93():import44.NoPreloading {
    if ((this.__NoPreloading_93 == (null as any))) { (this.__NoPreloading_93 = new import44.NoPreloading()); }
    return this.__NoPreloading_93;
  }
  get _PreloadAllModules_94():import44.PreloadAllModules {
    if ((this.__PreloadAllModules_94 == (null as any))) { (this.__PreloadAllModules_94 = new import44.PreloadAllModules()); }
    return this.__PreloadAllModules_94;
  }
  get _isBrowser_95():any {
    if ((this.__isBrowser_95 == (null as any))) { (this.__isBrowser_95 = true); }
    return this.__isBrowser_95;
  }
  get _isNode_96():any {
    if ((this.__isNode_96 == (null as any))) { (this.__isNode_96 = import116.isNode); }
    return this.__isNode_96;
  }
  get _req_97():any {
    if ((this.__req_97 == (null as any))) { (this.__req_97 = import1.getRequest()); }
    return this.__req_97;
  }
  get _res_98():any {
    if ((this.__res_98 == (null as any))) { (this.__res_98 = import1.getResponse()); }
    return this.__res_98;
  }
  createInternal():import1.MainModule {
    this._CommonModule_0 = new import2.CommonModule();
    this._ApplicationModule_1 = new import3.ApplicationModule();
    this._BrowserModule_2 = new import4.BrowserModule(this.parent.get(import4.BrowserModule,(null as any)));
    this._HttpModule_3 = new import5.HttpModule();
    this._JsonpModule_4 = new import5.JsonpModule();
    this._DOCUMENT_5 = import4._document();
    this._DomSharedStylesHost_6 = new import6.DomSharedStylesHost(this._DOCUMENT_5);
    this._SharedStylesHost_7 = this._DomSharedStylesHost_6;
    this._UniversalModule_8 = new import7.UniversalModule(this._SharedStylesHost_7);
    this._InternalFormsSharedModule_9 = new import8.InternalFormsSharedModule();
    this._FormsModule_10 = new import9.FormsModule();
    this._ROUTER_FORROOT_GUARD_11 = import10.provideForRootGuard(this.parent.get(import117.Router,(null as any)));
    this._RouterModule_12 = new import10.RouterModule(this._ROUTER_FORROOT_GUARD_11);
    this._IdlePreloadModule_13 = new import11.IdlePreloadModule();
    this._ReactiveFormsModule_14 = new import9.ReactiveFormsModule();
    this._PaginationModule_15 = new import12.PaginationModule();
    this._SharedModule_16 = new import13.SharedModule();
    this._Ng2InputMaskModule_17 = new import14.Ng2InputMaskModule();
    this._FileUploadModule_18 = new import15.FileUploadModule();
    this._AdminRoutingModule_19 = new import16.AdminRoutingModule();
    this._AdminModule_20 = new import17.AdminModule();
    this._FrontRoutingModule_21 = new import18.FrontRoutingModule();
    this._LazyLoadImageModule_22 = new import19.LazyLoadImageModule();
    this._FrontModule_23 = new import20.FrontModule();
    this._AppModule_24 = new import21.AppModule();
    this._LRU_25 = import1.getLRU();
    this._CacheService_26 = new import22.CacheService(this._LRU_25);
    this._MainModule_27 = new import1.MainModule(this._CacheService_26);
    this._ErrorHandler_30 = import4.errorHandler();
    this._ApplicationInitStatus_31 = new import24.ApplicationInitStatus(this.parent.get(import24.APP_INITIALIZER,(null as any)));
    this._Testability_32 = new import25.Testability(this.parent.get(import89.NgZone));
    this._ApplicationRef__33 = new import26.ApplicationRef_(this.parent.get(import89.NgZone),this.parent.get(import118.Console),this,this._ErrorHandler_30,this,this._ApplicationInitStatus_31,this.parent.get(import25.TestabilityRegistry,(null as any)),this._Testability_32);
    this._RouterPreloader_71 = new import44.RouterPreloader(this._Router_67,this._NgModuleFactoryLoader_65,this._Compiler_35,this,this._PreloadingStrategy_70);
    return this._MainModule_27;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CommonModule)) { return this._CommonModule_0; }
    if ((token === import3.ApplicationModule)) { return this._ApplicationModule_1; }
    if ((token === import4.BrowserModule)) { return this._BrowserModule_2; }
    if ((token === import5.HttpModule)) { return this._HttpModule_3; }
    if ((token === import5.JsonpModule)) { return this._JsonpModule_4; }
    if ((token === import119.DOCUMENT)) { return this._DOCUMENT_5; }
    if ((token === import6.DomSharedStylesHost)) { return this._DomSharedStylesHost_6; }
    if ((token === import6.SharedStylesHost)) { return this._SharedStylesHost_7; }
    if ((token === import7.UniversalModule)) { return this._UniversalModule_8; }
    if ((token === import8.InternalFormsSharedModule)) { return this._InternalFormsSharedModule_9; }
    if ((token === import9.FormsModule)) { return this._FormsModule_10; }
    if ((token === import10.ROUTER_FORROOT_GUARD)) { return this._ROUTER_FORROOT_GUARD_11; }
    if ((token === import10.RouterModule)) { return this._RouterModule_12; }
    if ((token === import11.IdlePreloadModule)) { return this._IdlePreloadModule_13; }
    if ((token === import9.ReactiveFormsModule)) { return this._ReactiveFormsModule_14; }
    if ((token === import12.PaginationModule)) { return this._PaginationModule_15; }
    if ((token === import13.SharedModule)) { return this._SharedModule_16; }
    if ((token === import14.Ng2InputMaskModule)) { return this._Ng2InputMaskModule_17; }
    if ((token === import15.FileUploadModule)) { return this._FileUploadModule_18; }
    if ((token === import16.AdminRoutingModule)) { return this._AdminRoutingModule_19; }
    if ((token === import17.AdminModule)) { return this._AdminModule_20; }
    if ((token === import18.FrontRoutingModule)) { return this._FrontRoutingModule_21; }
    if ((token === import19.LazyLoadImageModule)) { return this._LazyLoadImageModule_22; }
    if ((token === import20.FrontModule)) { return this._FrontModule_23; }
    if ((token === import21.AppModule)) { return this._AppModule_24; }
    if ((token === 'LRU')) { return this._LRU_25; }
    if ((token === import22.CacheService)) { return this._CacheService_26; }
    if ((token === import1.MainModule)) { return this._MainModule_27; }
    if ((token === import120.LOCALE_ID)) { return this._LOCALE_ID_28; }
    if ((token === import23.NgLocalization)) { return this._NgLocalization_29; }
    if ((token === import121.ErrorHandler)) { return this._ErrorHandler_30; }
    if ((token === import24.ApplicationInitStatus)) { return this._ApplicationInitStatus_31; }
    if ((token === import25.Testability)) { return this._Testability_32; }
    if ((token === import26.ApplicationRef_)) { return this._ApplicationRef__33; }
    if ((token === import26.ApplicationRef)) { return this._ApplicationRef_34; }
    if ((token === import27.Compiler)) { return this._Compiler_35; }
    if ((token === import122.APP_ID)) { return this._APP_ID_36; }
    if ((token === import28.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_37; }
    if ((token === import29.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_38; }
    if ((token === import29.EventManager)) { return this._EventManager_39; }
    if ((token === import123.AnimationDriver)) { return this._AnimationDriver_40; }
    if ((token === import30.DomRootRenderer)) { return this._DomRootRenderer_41; }
    if ((token === import115.RootRenderer)) { return this._RootRenderer_42; }
    if ((token === import31.DomSanitizer)) { return this._DomSanitizer_43; }
    if ((token === import124.Sanitizer)) { return this._Sanitizer_44; }
    if ((token === import32.ViewUtils)) { return this._ViewUtils_45; }
    if ((token === import125.IterableDiffers)) { return this._IterableDiffers_46; }
    if ((token === import126.KeyValueDiffers)) { return this._KeyValueDiffers_47; }
    if ((token === import33.Title)) { return this._Title_48; }
    if ((token === import34.BrowserXhr)) { return this._BrowserXhr_49; }
    if ((token === import35.ResponseOptions)) { return this._ResponseOptions_50; }
    if ((token === import127.XSRFStrategy)) { return this._XSRFStrategy_51; }
    if ((token === import36.XHRBackend)) { return this._XHRBackend_52; }
    if ((token === import37.RequestOptions)) { return this._RequestOptions_53; }
    if ((token === import128.Http)) { return this._Http_54; }
    if ((token === import38.BrowserJsonp)) { return this._BrowserJsonp_55; }
    if ((token === import39.JSONPBackend)) { return this._JSONPBackend_56; }
    if ((token === import128.Jsonp)) { return this._Jsonp_57; }
    if ((token === import7.UNIVERSAL_CACHE)) { return this._UNIVERSAL_CACHE_58; }
    if ((token === import7.AUTO_PREBOOT)) { return this._AUTO_PREBOOT_59; }
    if ((token === import40.UrlSerializer)) { return this._UrlSerializer_60; }
    if ((token === import41.RouterOutletMap)) { return this._RouterOutletMap_61; }
    if ((token === import10.ROUTER_CONFIGURATION)) { return this._ROUTER_CONFIGURATION_62; }
    if ((token === import92.LocationStrategy)) { return this._LocationStrategy_63; }
    if ((token === import42.Location)) { return this._Location_64; }
    if ((token === import129.NgModuleFactoryLoader)) { return this._NgModuleFactoryLoader_65; }
    if ((token === import130.ROUTES)) { return this._ROUTES_66; }
    if ((token === import117.Router)) { return this._Router_67; }
    if ((token === import11.REQUEST_IDLE_CALLBACK)) { return this._REQUEST_IDLE_CALLBACK_68; }
    if ((token === import11.IdlePreload)) { return this._IdlePreload_69; }
    if ((token === import44.PreloadingStrategy)) { return this._PreloadingStrategy_70; }
    if ((token === import44.RouterPreloader)) { return this._RouterPreloader_71; }
    if ((token === import122.APP_BOOTSTRAP_LISTENER)) { return this._APP_BOOTSTRAP_LISTENER_72; }
    if ((token === import45.RadioControlRegistry)) { return this._RadioControlRegistry_73; }
    if ((token === import46.FormBuilder)) { return this._FormBuilder_74; }
    if ((token === import47.MaskService)) { return this._MaskService_75; }
    if ((token === import48.ConfigService)) { return this._ConfigService_76; }
    if ((token === import49.UtilsService)) { return this._UtilsService_77; }
    if ((token === import50.ContentService)) { return this._ContentService_78; }
    if ((token === import51.CookieService)) { return this._CookieService_79; }
    if ((token === import52.CartService)) { return this._CartService_80; }
    if ((token === import53.ApiService)) { return this._ApiService_81; }
    if ((token === import54.ModelService)) { return this._ModelService_82; }
    if ((token === import55.AuthService)) { return this._AuthService_83; }
    if ((token === import56.AuthGuard)) { return this._AuthGuard_84; }
    if ((token === import57.DataService)) { return this._DataService_85; }
    if ((token === import58.ElasticSearchService)) { return this._ElasticSearchService_86; }
    if ((token === import59.SearchService)) { return this._SearchService_87; }
    if ((token === import60.Meta)) { return this._Meta_88; }
    if ((token === import61.MetaService)) { return this._MetaService_89; }
    if ((token === import62.NotificationService)) { return this._NotificationService_90; }
    if ((token === import63.IntlService)) { return this._IntlService_91; }
    if ((token === import131.ActivatedRoute)) { return this._ActivatedRoute_92; }
    if ((token === import44.NoPreloading)) { return this._NoPreloading_93; }
    if ((token === import44.PreloadAllModules)) { return this._PreloadAllModules_94; }
    if ((token === 'isBrowser')) { return this._isBrowser_95; }
    if ((token === 'isNode')) { return this._isNode_96; }
    if ((token === 'req')) { return this._req_97; }
    if ((token === 'res')) { return this._res_98; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ApplicationRef__33.ngOnDestroy();
    this._RouterPreloader_71.ngOnDestroy();
  }
}
export const MainModuleNgFactory:import0.NgModuleFactory<import1.MainModule> = new import0.NgModuleFactory(MainModuleInjector,import1.MainModule);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/browser.module.ngfactory.ts